import { DataSourceFactory } from 'app/components'

interface IUserData {
  username: string
  firstname: string
  lastname: string
  email: string
}

const additionalHeaders = { Authorization: null }

const filterBody = { name: '' }

const UserDataSources = DataSourceFactory.create<IUserData>({
  transport: {
    read: {
      url: 'https://r0okaqxkp2.execute-api.us-east-1.amazonaws.com/Test/listusers',
      insertBodyBeforeRequest: () => JSON.stringify(filterBody),
      request: {
        method: 'POST',
      }
    }
  }
})

const setAuthorizationAndSync = (authorization: string) => {
  additionalHeaders.Authorization = authorization

  UserDataSources.sync()
}

const filterAndSyncUserDataSource = (name: string) => {
  filterBody.name = name

  UserDataSources.sync()
}

export {
  filterAndSyncUserDataSource,
  setAuthorizationAndSync,
  UserDataSources,
  IUserData
}



// WEBPACK FOOTER //
// ./src/app/containers/UserAdmin/Datasource.ts